/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import * as Services from '../../services/endpoints'
import { IPAConfig, ConfigBody } from '../../types'
import { createGenericSlice, GenericState } from '../lib'
import { downloadFile } from '../../utils/helpers'
import { formatError } from '../lib/errors'

const sliceName = 'configs'

//todo should rename to ipa config, or analyzer config or something - config is too generic
//todo need to reverse this and use the sate as the type
export interface ConfigState extends GenericState<IPAConfig> {
  selectedConfig: null | IPAConfig //Get rid of this later
}

const configAdapter = createEntityAdapter<IPAConfig>({
  selectId: (obj) => (obj ? obj.id : '')
})

export const initialConfigsState: ConfigState = {
  ids: [],
  entities: {},
  loading: false,
  error: null,
  selectedConfig: null
}

export const getConfig = createAsyncThunk(
  `${sliceName}/getConfig`,
  async (
    params: { configId: string; scriptId: string },
    { rejectWithValue }
  ) => {
    try {
      return await Services.getConfig(params.scriptId, params.configId)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const getConfigFile = createAsyncThunk(
  `${sliceName}/getConfig`,
  async (
    params: { scriptId: string; configId: string },
    { rejectWithValue }
  ) => {
    try {
      return await Services.getConfigFile(params.scriptId, params.configId)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const getConfigs = createAsyncThunk(
  `${sliceName}/getConfigs`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.getConfigs(id)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const createConfig = createAsyncThunk(
  `${sliceName}/createConfig`,
  async (params: { id: string; body: any }, { rejectWithValue }) => {
    try {
      return await Services.createConfig(params.id, params.body as ConfigBody)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const removeConfig = createAsyncThunk(
  `${sliceName}/removeConfig`,
  async (params: { sId: string; cId: string }, { rejectWithValue }) => {
    try {
      await Services.removeConfig(params.sId, params.cId)
      return params.cId
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const updateConfig = createAsyncThunk(
  `${sliceName}/updateConfig`,
  async (
    params: { scriptId: string; configId: string; body: any },
    { rejectWithValue }
  ) => {
    try {
      return await Services.updateConfig(
        params.scriptId,
        params.configId,
        params.body
      )
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const downloadConfigFile = createAsyncThunk(
  `${sliceName}/downloadConfigFile`,
  async (
    data: { data: string | Blob; fileName: string; contentType?: string },
    { rejectWithValue }
  ) => {
    try {
      return await downloadFile(
        data.data,
        data.fileName,
        (data.contentType = 'text/plain')
      )
    } catch (err: any) {
      const e = formatError(err)
      return rejectWithValue(e)
    }
  }
)

const thunkAdapters: any = [
  {
    adapterFn: (state, action) => {
      configAdapter.setAll(state, [action])
    },
    thunk: getConfig
  },
  {
    adapterFn: configAdapter.setAll,
    thunk: getConfigs
  },
  {
    adapterFn: (state, action) => {
      const config = action?.json ?? action
      if (config?.id) {
        configAdapter.addOne(state, config)
      }
    },
    thunk: createConfig
  },
  {
    adapterFn: configAdapter.removeOne,
    thunk: removeConfig
  },
  {
    adapterFn: (state, action) => {
      configAdapter.upsertOne(state, action.json)
    },
    thunk: updateConfig
  }
]

export const configsSlice = createGenericSlice({
  name: sliceName,
  initialState: initialConfigsState,
  reducers: {},
  thunkAdapters
})
